import {IFormButtonWatcher, EFormButtonWatcherConnective} from './use-form-button-watcher-types';

export const createConnective = (
    connective: IFormButtonWatcher['conditions'][0]['withConnective'],
) => (a: boolean, b: boolean) => {
    if (!connective) return a && b;
    if (connective === EFormButtonWatcherConnective.AND) return a && b;
    if (connective === EFormButtonWatcherConnective.AND_NOT) return a && !b;
    if (connective === EFormButtonWatcherConnective.OR_NOT) return a || !b;
    return a || b;
};
